<template>
	<footer :class="['footer', themeCssClass]">
		<div class="footer-line">
			© {{year}} {{legalCompanyName}} | All Rights Reserved
		</div>
	</footer>
</template>


<script>
    import AppConfig from '@/config';
    import { account } from '@/services';
    import { actions, store, getters } from '@/store';

	export default {
        name: 'app-footer',
        data() {
            return {
                legalCompanyName: AppConfig.brand.legalCompanyName,
                routeName: this.$router.currentRoute.name
            };
        },
        computed: {
            themeCssClass() {
                if (this.routeName !== 'dashboards' && this.routeName !== 'group-dashboards')
                    return 'theme-light';

                var theme = store.getters[getters.THEME];
                return theme ? `theme-${theme}` : 'theme-light';
            },
            year() {
                var today = new Date();
                var nextYear = today.getFullYear() !== 2018 ? `-${today.getFullYear().toString()}` : '';
                return `2018${nextYear}`;
            }
        },
        watch: {
            $route (to, from) {
                this.routeName = to.name;
            }
        },
        beforeMount() {
            store.dispatch(actions.THEME_LOAD);
        }
	};
</script>


<style lang="scss" scoped>
@import '~@/assets/styles/references';

/* Footer/Copyright
**********************************/
.footer { position: fixed; left: 0; bottom: 0; text-align: center; font-size: $font-size-xs; padding: gx(0.5); }
.footer-line { margin-bottom: gx(0.5);
	a { color: inherit; white-space: nowrap; }
}
.theme-dark { color: color(white, hint); }
.theme-light { color: color(black, secondary); }
</style>
